document.addEventListener('DOMContentLoaded', function() {
  const guideSelect = document.querySelector('.guide-select');
  const guideItems = document.querySelectorAll('.guide-item');

  guideSelect.addEventListener('change', function() {
    const selectedOption = this.options[this.selectedIndex].value;

    guideItems.forEach(function(item) {
      if (item.id === selectedOption) {
        item.style.display = 'block';
      } else {
        item.style.display = 'none';
      }
    });
  });

  // Initialize guide items visibility based on the initial selected option
  const initialSelectedOption = guideSelect.options[guideSelect.selectedIndex].value;
  guideItems.forEach(function(item) {
    if (item.id === initialSelectedOption) {
      item.style.display = 'block';
    } else {
      item.style.display = 'none';
    }
  });
});
